import Types from "./Types";
import API from '@beardeddevops/react.api';

export const setTimestamp = (key) => {
	console.log('SETTING TIMESTAMP')
	localStorage.setItem(key, Date.now().toString());
};


export const hasMinutesPassed = (key, minutes) => {
	const raw = localStorage.getItem(key);
	if (!raw) return true; // never set → treat as expired

	const last = Number(raw);
	if (Number.isNaN(last)) return true;

	const elapsedMs = Date.now() - last;
	return elapsedMs >= minutes * 60 * 1000;
};


//use this for basic comparisons
export function isDirtySafe(prevState = {}, nextState = {}, keys = []) {
	return keys.some(
		(key) => !Object.is(prevState[key], nextState[key])
	);
}

//use this for keys that are objects or arrays
export function isDirtyDeep(prevState, nextState, keys) {
	return keys.some((key) => {
		return JSON.stringify(prevState[key]) !== JSON.stringify(nextState[key]);
	});
}

//currently only used in the NavLeftList but I can see using most of these elsewhere
export const now = () => Date.now();

export const minutes = (n) => n * 60 * 1000;

export const getTs = (key) => {
	const v = localStorage.getItem(key);
	return v ? Number(v) : null;
};

export const setTs = (key) => {
	localStorage.setItem(key, now().toString());
};

export const clearTs = (key) => {
	localStorage.removeItem(key);
};

/**
 * Parse a lat/lng string (including legacy "lat,+-lng" from .split(' ').join('+')).
 * @returns {{latitude: number, longitude: number}|null}
 */
export const parseLatLngString = (value) => {
	if (value == null) {
		return null;
	}
	if (typeof value === "object") {
		const lat = parseFloat(value.latitude ?? value.lat);
		const lng = parseFloat(value.longitude ?? value.lng ?? value.long);
		if (Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180) {
			return {latitude: lat, longitude: lng};
		}
		return null;
	}

	const cleaned = String(value).replace(/\+/g, "").trim();
	const match = cleaned.match(/^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)$/);
	if (!match) {
		return null;
	}
	const latitude = parseFloat(match[1]);
	const longitude = parseFloat(match[2]);
	if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
		return null;
	}
	if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) {
		return null;
	}
	return {latitude, longitude};
};

//wrapper to call our API for geocode stuffs
export const Call_Geocode_API = async (location = null, options = {}) => {
	const {suppressToast = false} = options;

	if (!location) {
		if (!suppressToast) {
			API.Toast.error("Missing location for geocode.", {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 2000
			});
		}
		return {};
	}

	let filter = {};

	if (typeof location === "string") {
		filter.location = location.trim();
	} else if (typeof location === "object") {
		filter = {
			...location,
			location: location.location?.trim?.() || location.full_address?.trim?.() || null,
		};
	}

	// Already coordinates - normalize (fix "lat,+-lng") and skip address geocode when possible
	const asCoords = parseLatLngString(
		typeof location === "string" ? location : (filter.location || location)
	);
	if (asCoords && (typeof location === "string" || !filter.street_1)) {
		filter.location = `${asCoords.latitude},${asCoords.longitude}`;
	}

	if (!filter.location) {
		if (!suppressToast) {
			API.Toast.error("Missing location for geocode.", {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 2000
			});
		}
		return {};
	}

	const model = API.BuildClass(Types.Geo_Coords._name, "GET");
	model.filter = filter;

	const res = await model.submit(null, "GET_GEOCODE", suppressToast);

	if (!res || !res?.items) {
		return {};
	}

	return res.items;
};

/** Parse coords when possible; otherwise geocode an address string. */
export const resolveLatLng = async (value) => {
	const parsed = parseLatLngString(value);
	if (parsed) {
		return parsed;
	}
	if (!value || typeof value !== "string") {
		return {};
	}
	return Call_Geocode_API(value, {suppressToast: true});
};